var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScalability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_51",
    "data-name": "Layer 51",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #15233f;\n      }\n\n      .cls-2 {\n        fill: #c2c7cc;\n        opacity: .25;\n      }\n\n      .cls-3 {\n        fill: #4f7fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 250,
    cy: 250,
    r: 162.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.24,
    y: 223.66,
    width: 109.33,
    height: 176.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 192.24,
    y: 150,
    width: 109.33,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 322.43,
    y: 100,
    width: 109.33,
    height: 300
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScalability);
export default __webpack_public_path__ + "static/media/icon_scalability.858ceb6e1f78ba1c892c1d74089debb7.svg";
export { ForwardRef as ReactComponent };